import React from "react";
import {useNavigate} from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import MenuIcon from "@mui/icons-material/Menu";
import ClassIcon from "@mui/icons-material/Class";


function Navbar({signOut}) {
	const pages = [{
		id: 1,
		text: "Students",
		link: "/"
	}];
	const settings = [{
		id: 1,
		text: "Logout",
		icon: <LogoutRoundedIcon/>,
		onClick: signOut
	}];

	const navigate = useNavigate();

	const [anchorElNav, setAnchorElNav] = React.useState(null);
	const [anchorElUser, setAnchorElUser] = React.useState(null);

	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget);
	};
	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseNavMenu = (link) => {
		if (link) {navigate(link)}
		setAnchorElNav(null);
	};

	const handleCloseUserMenu = (func) => {
		if (func) {func()}
		setAnchorElUser(null);
	};

	return (
		<AppBar position="static">
			<Container maxWidth="xl">
				<Toolbar disableGutters>
					<ClassIcon sx={{display: {xs: "none", md: "flex"}, mr: 1}}/>
					<Typography
						variant="h6"
						noWrap
						component="a"
						href="/"
						sx={{
							mr: 2,
							display: {xs: "none", md: "flex"},
							fontWeight: 700,
							color: "inherit",
							textDecoration: "none",
						}}
					>
						Tuition Diaries
					</Typography>

					<Box sx={{flexGrow: 1, display: {xs: "flex", md: "none"}}}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							onClick={handleOpenNavMenu}
							color="inherit"
						>
							<MenuIcon/>
						</IconButton>
						<Menu
							id="menu-appbar"
							anchorEl={anchorElNav}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
							keepMounted
							transformOrigin={{
								vertical: "top",
								horizontal: "left",
							}}
							open={Boolean(anchorElNav)}
							onClose={() => handleCloseNavMenu()}
							sx={{
								display: {xs: "block", md: "none"},
							}}
						>
							{pages.map((page) => (
								<MenuItem key={page.id} onClick={() => handleCloseNavMenu(page.link)}>
									<Typography textAlign="center">{page.text}</Typography>
								</MenuItem>
							))}
						</Menu>
					</Box>
					<ClassIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
					<Typography
						variant="h5"
						noWrap
						component="a"
						href=""
						sx={{
							mr: 2,
							display: {xs: "flex", md: "none"},
							flexGrow: 1,
							fontWeight: 700,
							color: "inherit",
							textDecoration: "none",
						}}
					>
						Tuition Diaries
					</Typography>
					<Box sx={{flexGrow: 1, display: {xs: "none", md: "flex"}}}>
						{pages.map((page) => (
							<Button
								key={page.id}
								onClick={() => handleCloseNavMenu(page.link)}
								sx={{my: 2, color: "white", display: "block"}}
							>
								{page.text}
							</Button>
						))}
					</Box>

					<Box sx={{flexGrow: 0}}>
						<Tooltip title="Open settings">
							<IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
								<Avatar alt="Semy Sharp" src="/static/images/avatar/2.jpg"/>
							</IconButton>
						</Tooltip>
						<Menu
							sx={{mt: "45px"}}
							id="menu-appbar"
							anchorEl={anchorElUser}
							anchorOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							keepMounted
							transformOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							open={Boolean(anchorElUser)}
							onClose={() => handleCloseUserMenu()}
						>
							{settings.map((setting) => (
								<MenuItem key={setting.id} onClick={() => handleCloseUserMenu(setting.onClick)}>
									<Typography textAlign="center">{setting.icon} {setting.text}</Typography>
								</MenuItem>
							))}
						</Menu>
					</Box>
				</Toolbar>
			</Container>
		</AppBar>
	);
}

export default Navbar;
